import Price from "components/Price/Price"
import DropdownQuantities from "components/Product/DropdownQuantities"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import { Button, Image } from "semantic-ui-react"

const QuickorderRow = ( { product, handleRemoveProduct, onChange } ) => {
  return (
    <tr>
      <td>
        <Button size="tiny" basic icon="cancel" onClick={handleRemoveProduct.bind( null, product )}/>
      </td>
      <td>
        <Link to={`/product/${product.map_id}`}>
          <Image centered className="img-responsive" style={{
            maxWidth:  33,
            maxHeight: 33
          }} src={product.img_src_small} alt=""/>
        </Link>
      </td>
      <td>
        <strong>{product.article_nr}</strong> <span className="product-title">{product.title}</span> <br/>
        {/*<span className="unit_multi black-50">{product.unit_desc}</span>*/}
      </td>
      <td><span className="f6">{product.getNotice( "tiny" )}</span></td>
      <td><Price>{product.price}</Price></td>
      <td><Price>{product.price * product.unit_multi}</Price></td>
      <td> {product.unit_multi * product.count} {product.unit_desc}</td>

      <td>
        <Price>{product.price * product.count * product.unit_multi}</Price>
      </td>

      <td>
        {product.quantities.length > 1 && <div className={"fl"}>
          <DropdownQuantities product={product} onChange={onChange}/>
        </div>}
      </td>

      <td className="tr">
        <ProductCount product={product} onChange={onChange}/>
      </td>

    </tr>
  )
}



QuickorderRow.propTypes = {
  handleRemoveProduct: PropTypes.func.isRequired,
  product:             PropTypes.object.isRequired,
}

export default QuickorderRow


// WEBPACK FOOTER //
// ./src/components/Quickorder/QuickorderRow.js